import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'GenericTransform',
})
export class GenericTransformPipe implements PipeTransform {

    transform(input: any, transformFunc: (value: any, optional?: any) => any | number, args: any = null): any {
        return transformFunc(input, args);
    }
}
